import styled from 'styled-components';

export default styled.div`
      
        &.stolo-cart-wrapper {
            display: flex;
            align-items: stretch;
            justify-content: flex-end;
            flex-wrap: wrap;
            color: ${props => props.theme.palette.common.text};
            margin: 0 0.5em;
        }
        
        & legend {
          color: ${props => props.theme.palette.blueGrey[700]};
          font-family: ${props => props.theme.typography.condensed};
          font-size: ${props => props.theme.fontSizes[9]};
          margin-bottom: ${props => props.theme.space[7]};
        }
`;



// WEBPACK FOOTER //
// ./src/components/styles/AddToCartWrapper.js